import { useCallback, useContext } from 'react';
import { Dispatch } from 'redux';
import { ReactReduxContext } from 'react-redux';
import { ITmdState } from 'src/reducers';



export const useActionCreator = <T extends (...args: any) => any>(actionCreator: T, dispatch: Dispatch<ITmdState>) => {
    return useCallback((...args: Parameters<T>) => {
        dispatch(actionCreator(...args));
    }, [actionCreator, dispatch]);
}

const useDispatch = () => {
    const context = useContext(ReactReduxContext);

    return context.store.dispatch;
}

export default useDispatch;